import { render, staticRenderFns } from "./acceptance.vue?vue&type=template&id=08077174&scoped=true&"
import script from "./acceptance.vue?vue&type=script&lang=js&"
export * from "./acceptance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08077174",
  null
  
)

export default component.exports